import { DamagedPartsSelectedQueryParamsType } from '@/common/components/camera/queries/damagedPartsSelected/damagedPartsSelectedQuery.type';
import { damagedPartsSelectedFunction } from '@/common/components/camera/queries/damagedPartsSelected/damagedPartsSelectedQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const damagedPartsSelectedQueryOptions = ({
  params,
  enabled,
}: DamagedPartsSelectedQueryParamsType) => {
  return queryOptions({
    queryKey: [
      'DAMAGED_PARTS_SELECTED',
      params.damaged_id,
      params.id,
      params?.participantRoleType,
    ],
    queryFn: () =>
      damagedPartsSelectedFunction({
        params: {
          damaged_id: params.damaged_id,
          id: params.id,
          participantRoleType: params?.participantRoleType,
        },
      }),

    enabled: enabled ?? false,
  });
};
